import {rtkApi} from '../../apiSlice';
import {rtkActionHandler} from '../../rtkHandler';
import {
    createSubRole,
    deleteSubRole,
    editSubRole,
    getMainModules,
    getRoleDetails,
    getUserRoles,
    getUserSubRoles,
    updateSubRoleModules
} from "@/redux/apis/admin/settings/roles/api";
import {CREATE_ROLE, EDIT_ROLE, SUB_ROLE_MODULE} from "@/redux/rtk/admin/settings/types";

const apiWithPortalAdministrationTag = rtkApi.enhanceEndpoints?.({ addTagTypes: [] });

export const rolesApi = apiWithPortalAdministrationTag.injectEndpoints({
    endpoints: (builder) => ({
        getUserRoles: builder.query<any, any>({
            queryFn: async () => {
                return rtkActionHandler(getUserRoles());
            },
        }),
        getRoleDetails: builder.query<any, number>({
            queryFn: async (uid: number) => {
                return rtkActionHandler(getRoleDetails({uid}));
            },
        }),
        getUserSubRoles: builder.mutation<any, number>({
            queryFn: async (type: number) => {
                return rtkActionHandler(getUserSubRoles({type}));
            },
        }),
        createSubRole: builder.mutation<any, CREATE_ROLE>({
            queryFn: async (data: CREATE_ROLE) => {
                return rtkActionHandler(createSubRole(data));
            },
        }),
        editSubRole: builder.mutation<any, EDIT_ROLE>({
            queryFn: async (data: EDIT_ROLE) => {
                return rtkActionHandler(editSubRole(data));
            },
        }),
        deleteSubRole: builder.mutation<any, number>({
            queryFn: async (uid: number) => {
                return rtkActionHandler(deleteSubRole({uid}));
            },
        }),
        getMainModules: builder.query<any, number>({
            queryFn: async (uid: number) => {
                return rtkActionHandler(getMainModules({uid}));
            },
        }),
        updateSubRoleModules: builder.mutation<any, SUB_ROLE_MODULE>({
            queryFn: async (data: SUB_ROLE_MODULE) => {
                return rtkActionHandler(updateSubRoleModules(data));
            },
        }),
    })
});

export const {
    useGetUserRolesQuery,
    useGetUserSubRolesMutation,
    useCreateSubRoleMutation,
    useEditSubRoleMutation,
    useDeleteSubRoleMutation,
    useGetRoleDetailsQuery,
    useGetMainModulesQuery,
    useUpdateSubRoleModulesMutation
} = rolesApi;